<template>
  <div class="content">
    <controlbar
      :dispItems="templates"
      @input-event="setTemplates"
      @list-reload="reload"
    >
    </controlbar>
    <div class="center">
      <table class="content_title" rules="rows">
        <tr class="items_table">
          <th class="table_checkbox">
            <input
              type="checkbox"
              class="checkbox"
              :checked="checked"
              @click="allCheckedAction"
            />
          </th>
          <td class="table_contents">
            <label class="name_label">
              {{ titleLabel }}
            </label>
          </td>
        </tr>
      </table>

      <div class="table_scroll" :style="{height: tableHeight}">
        <table class="items_table" rules="rows">
          <tr
            class="item_table_row"
            v-for="dispTemplate in templates"
            :key="dispTemplate.id"
          >
            <th class="table_checkbox">
              <input
                type="checkbox"
                class="checkbox"
                v-model="dispTemplate.checked"
                @click="checkedAction(dispTemplate)"
              />
            </th>
            <td class="table_contents" @click="setActive(dispTemplate)">
              <label>
                {{ dispTemplate.title }}
              </label>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="bottom">
      <pagination
        v-model="page"
        :records="total"
        :per-page="pageSize"
        :options="{texts: {count: '{from} - {to}/{count}件'}, chunk: 5}"
        @paginate="setTemplates(page - 1)"
      >
      </pagination>
    </div>
    <div class="false_modal_window" v-if="showFalseModal">
      <falseModalWindow :question="falseWord" @close="close">
      </falseModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import controlbar from './controlbar.vue'
import falseModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import Pagination from 'vue-pagination-2'

export default {
  data() {
    return {
      titleLabel: 'タイトル',
      showFalseModal: false,
      showCompleteModal: false,
      windowHeight: '',
      falseWord: '',
      checked: false,
      inputValue: '',
      showloadingModal: false,
      pageSize: 20,
      page: 1,
      prevTotal: 0,
      prevPageNo: 0
    }
  },
  computed: {
    templates() {
      return this.$store.state.template.templates
    },
    total() {
      if ((this.page - 1) * this.pageSize <= this.$store.state.template.total) {
        return this.$store.state.template.total
      }
      return this.prevTotal
    },
    isOverPage() {
      return (this.page - 1) * this.pageSize >= this.$store.state.template.total
    },
    lastPage() {
      const last = Math.ceil(this.$store.state.template.total / this.pageSize)
      return last === 0 ? 1 : last
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    tableHeight() {
      const otherHeight = 138
      return this.windowHeight - otherHeight + 'px'
    }
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
    this.$store.dispatch('template/clearSelectedTemplateList')
    this.$store.state.prevPageNo = 0
    this.setTemplates(0)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    controlbar,
    falseModalWindow,
    loadingModalWindow,
    Pagination
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    allCheckedAction(e) {
      // リストのチェックボックスを全てチェックする。
      this.checked = !this.checked
      for (let i = 0; i < this.templates.length; i++) {
        this.templates[i].checked = this.checked
      }
      this.$store.dispatch(
        'template/updateSelectedTemplateList',
        this.templates
      )
    },
    checkedAction(template) {
      template.checked = !template.checked
      this.$store.dispatch('template/updateSelectedTemplateList', [template])
    },
    close(e) {
      this.showFalseModal = false
      this.showCompleteModal = false
    },
    async reload() {
      this.$store.dispatch('template/clearSelectedTemplateList')
      await this.setTemplates(this.$store.state.prevPageNo)
    },
    async setTemplates(pageNo) {
      this.showloadingModal = true
      let focus = document.activeElement
      focus.blur()
      try {
        await this.$store.dispatch('template/setTemplates', {
          pageNo: pageNo
        })
        if (this.isOverPage) {
          this.page = this.lastPage
        } else {
          this.page = pageNo + 1
        }
        this.$store.state.prevPageNo = pageNo
        this.checked = false
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_710001
        let eventType = 3
        let reason = 'MSGCRC0307'
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRC0307.name +
            this.errorMsg.MSGCRC0307.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    },
    async setActive(payload) {
      this.showloadingModal = true
      let tr = event.currentTarget.parentNode.parentNode.querySelectorAll('tr')
      for (let i = 0; i < tr.length; i++) {
        tr[i].className = 'item_table_row'
      }
      event.currentTarget.parentNode.className = 'item_table_row active'
      try {
        await this.$store.dispatch('template/setDetailTemplate', payload)
        if (location.pathname !== '/template/detail') {
          this.$router.push('../template/detail')
        }
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_710001
        let eventType = 3
        let reason = 'MSGCRC0308'
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRC0308.name +
            this.errorMsg.MSGCRC0308.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>
<style scoped>
td {
  width: 25%;
}
</style>



// WEBPACK FOOTER //
// src/components/template/templateList.vue